import { render, staticRenderFns } from "./newCouponCode.vue?vue&type=template&id=00662967&scoped=true&"
import script from "./newCouponCode.vue?vue&type=script&lang=js&"
export * from "./newCouponCode.vue?vue&type=script&lang=js&"
import style0 from "./newCouponCode.vue?vue&type=style&index=0&id=00662967&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00662967",
  null
  
)

export default component.exports